// extracted by mini-css-extract-plugin
export default {"addDealModal":"supplierStyles_addDealModal__HQ9L7","accountModal":"supplierStyles_accountModal__M81h-"};